export const SET_SELECTED_ECR_EXTRA_FILTER = 'component-repository/extra-filters/set-selected-extra-filter';
export const SET_ECR_EXTRA_FILTERS = 'component-repository/extra-filters/set-extra-filters';
